import React, { FC } from 'react';
import { IMRBeaconSVGProps } from './icons.types';

const Bank: FC<IMRBeaconSVGProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M1.5 23.0245L2.386 20.4689C2.45398 20.273 2.64488 20.1408 2.86 20.1406H21.14C21.3551 20.1408 21.546 20.273 21.614 20.4689L22.5 23.0206"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 9.58398H20.5V20.144H3.5V9.58398Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 23.0234H0.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.50195 9.58398V20.144"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.50195 9.58398V20.144"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.502 9.58398V20.144"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.502 9.58398V20.144"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3704 7.07699C22.4457 6.86005 22.3511 6.62225 22.1444 6.50867L12.2484 1.07603C12.0937 0.990283 11.9031 0.990283 11.7484 1.07603L1.84838 6.50483C1.64165 6.61841 1.54709 6.85621 1.62238 7.07315L2.38638 9.25523C2.45435 9.45116 2.64526 9.58339 2.86038 9.58355H21.1404C21.3555 9.58339 21.5464 9.45116 21.6144 9.25523L22.3704 7.07699Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3331 6.70312H1.66211"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Bank;
